import React from "react";
import "./Experience.css";
import SkillItem from "./SkillItem";
import { motion } from "framer-motion";
import { backendMobileSkills, frontendSkills } from "../../data/experience.data";
import AnimatedHeadings from "../animatedHeadings/AnimatedHeadings";
import { experienceContainer, motionProps } from "../../animations";

const Experience = () => {
  return (
    <section id="experience">
      <AnimatedHeadings smallTitle="What Skills I Have" mainTitle="My Experience" />

      {/* Cards container */}
      <motion.div
        className="container experience__container"
        variants={experienceContainer}
        {...motionProps}
      >
        {/* FRONTEND */}
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            {frontendSkills.map((skill) => (
              <SkillItem key={skill.name} {...skill} />
            ))}
          </div>
        </div>

        {/* BACKEND */}
        <div className="experience__backend">
          <h3>Mobile & Backend</h3>
          <div className="experience__content">
            {backendMobileSkills.map((skill) => (
              <SkillItem key={skill.name} {...skill} />
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Experience;
